<template>
    <div class="modal-overlay" v-if="mostrar">
        <div class="modal-content">
            <div class="modal-icon" :class="tipo">
                <!-- Ícone de Sucesso -->
                <svg v-if="tipo === 'success'" class="icon-svg" viewBox="0 0 52 52">
                    <circle class="icon-circle" cx="26" cy="26" r="25" fill="none"/>
                    <path class="icon-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
                <!-- Ícone de Aviso -->
                <svg v-else-if="tipo === 'warning'" class="icon-svg" viewBox="0 0 52 52">
                    <circle class="icon-circle-warning" cx="26" cy="26" r="25" fill="none"/>
                    <path class="icon-warning" d="M26 14v16M26 34v4" stroke-linecap="round"/>
                </svg>
                <!-- Ícone de Erro -->
                <svg v-else-if="tipo === 'error'" class="icon-svg" viewBox="0 0 52 52">
                    <circle class="icon-circle-error" cx="26" cy="26" r="25" fill="none"/>
                    <path class="icon-x" d="M16 16l20 20M36 16L16 36" stroke-linecap="round"/>
                </svg>
            </div>
            <div class="modal-header">
                <h4>{{ titulo }}</h4>
            </div>
            <div class="modal-body">
                <p>{{ mensagem }}</p>
            </div>
            <div class="modal-footer">
                <button @click="fechar" class="btn-primary" :class="tipo">OK</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        mostrar: {
            type: Boolean,
            default: false
        },
        tipo: {
            type: String,
            default: 'success', // success, warning, error
            validator: (value) => ['success', 'warning', 'error'].includes(value)
        },
        titulo: {
            type: String,
            required: true
        },
        mensagem: {
            type: String,
            required: true
        }
    },
    methods: {
        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 1rem;
}

.modal-content {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    max-width: 450px;
    width: 100%;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
}

.dark .modal-content {
    background: #1e293b;
    color: #f1f5f9;
}

.modal-icon {
    width: 80px;
    height: 80px;
}

.icon-svg {
    width: 80px;
    height: 80px;
    display: block;
}

/* Success Icon */
.success .icon-circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 3;
    stroke: #10b981;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.success .icon-check {
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    stroke: #10b981;
    stroke-width: 3;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

/* Warning Icon */
.warning .icon-circle-warning {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 3;
    stroke: #f59e0b;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.warning .icon-warning {
    stroke: #f59e0b;
    stroke-width: 3;
    fill: none;
    opacity: 0;
    animation: fadeIn 0.3s ease-in 0.8s forwards;
}

/* Error Icon */
.error .icon-circle-error {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 3;
    stroke: #ef4444;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.error .icon-x {
    stroke: #ef4444;
    stroke-width: 3;
    fill: none;
    stroke-dasharray: 28;
    stroke-dashoffset: 28;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes fadeIn {
    100% {
        opacity: 1;
    }
}

.modal-header {
    text-align: center;
    width: 100%;
}

.modal-header h4 {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    color: #1f2937;
}

.dark .modal-header h4 {
    color: #f1f5f9;
}

.modal-body {
    text-align: center;
    width: 100%;
}

.modal-body p {
    color: #6b7280;
    line-height: 1.6;
    margin: 0;
}

.dark .modal-body p {
    color: #9ca3af;
}

.modal-footer {
    width: 100%;
}

.btn-primary {
    width: 100%;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s;
    color: white;
}

.btn-primary.success {
    background: #10b981;
}

.btn-primary.success:hover {
    background: #059669;
}

.btn-primary.warning {
    background: #f59e0b;
}

.btn-primary.warning:hover {
    background: #d97706;
}

.btn-primary.error {
    background: #ef4444;
}

.btn-primary.error:hover {
    background: #dc2626;
}
</style>
